'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const homeModule = angular
  .module('app.home', [])
  .config(homeConfig);

homeConfig.$inject = ['$routeProvider'];

function homeConfig($routeProvider) {
  $routeProvider
    .when('/scan-iq-home', {
      template: '<ngz-scan-iq-home></ngz-scan-iq-home>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.SCAN_IQ,
        breadcrumbs: [
          {
            label: 'Home',
            icon: NAVIGATION_ICON.HOME
          }
        ]
      }
    })
    .when('/nutrition-home', {
      template: '<ngz-nutrition-home></ngz-nutrition-home>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          {
            label: 'Home',
            icon: NAVIGATION_ICON.HOME
          }
        ]
      }
    })
    .when('/challenges-home', {
      template: '<ngz-challenges-home></ngz-challenges-home>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.CHALLENGE,
        breadcrumbs: [
          {
            label: 'Home',
            icon: NAVIGATION_ICON.HOME
          }
        ]
      }
    });
}
